<template>
    <div class="flex max-lg:flex-wrap lg:gap-4">
        <div class="max-lg:w-1/4 px-1 lg:px-4">
            <UAvatar :size="isDesktop ? '3xl' : 'xl'" :src="comment.avatar" :alt="comment.name" />
        </div>
        <div class="w-3/4 lg:w-4/6 grow">
            <div class="flex items-center justify-between">
                <UiComponentTypography :variant="isDesktop ? 'h4' : 'h6'">
                    <span v-if="comment.title">
                        {{ comment.title + " " }}
                    </span>
                    <span :class="{ 'mx-4': comment.title }" class="text-[.8em] opacity-75">
                        ({{ comment.name }})
                    </span>
                </UiComponentTypography>
                <div v-if="comment.score" class="flex gap-8">
                    <UiComponentTypography variant="subtitle"> امتیاز: </UiComponentTypography>
                    <div class="relative">
                        <span class="font-extrabold text-primary-500 text-xl leading-3">
                            {{ typeof comment.score === "string" ? parseFloat(comment.score) : comment.score }}
                        </span>
                        <span
                            class="absolute left-full top-full -translate-y-1/2 -translate-x-1/2 text-sm mx-2 -mt-1.5 text-gray-400">
                            5/
                        </span>
                    </div>
                </div>
            </div>
            <UiComponentHTML class="mt-2" :description="comment.content" />
            <div v-if="comment.replies && comment.replies.length > 0" class="pr-8 mt-4">
                <div class="flex gap-4">
                    <UiComponentTypography class-name="flex gap-2 items-center">
                        <UIcon name="i-solar-reply-2-bold-duotone" class="w-5 h-5 text-amazon-500" />
                        پاسخ‌ها
                    </UiComponentTypography>
                    <UDivider class="grow" :ui="{ border: { base: 'border-amazon-300' } }" />
                </div>
                <ul>
                    <li v-for="el in comment.replies" class="border-b last:border-b-0">
                        <div class="flex items-start gap-4 my-4">
                            <UAvatar :src="el.avatar" :alt="el.name" />
                            <div>
                                <UiComponentTypography variant="caption">
                                    {{ el.name }}
                                </UiComponentTypography>
                                <UiComponentHTML class="mt-2" :description="el.content" />
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="w-full lg:w-1/6 flex flex-col justify-center relative">
            <div
                class="lg:absolute lg:-top-4 lg:left-1/2 lg:-translate-x-1/2 lg:-translate-y-1/2 flex justify-center lg:justify-end gap-6 lg:gap-4 lg:border rounded-full px-4 bg-white">
                <div class="flex items-center gap-1">
                    <UButton variant="ghost" size="xs" color="gray" icon="i-solar-like-bold-duotone" />
                    <span class="text-xs text-gray-500">{{ comment.upvotes }}</span>
                </div>
                <div class="flex items-center gap-1">
                    <UButton variant="ghost" size="xs" color="gray" icon="i-solar-dislike-bold-duotone" />
                    <span class="text-xs text-gray-500">{{ comment.downvotes }}</span>
                </div>
            </div>
            <UDivider class="lg:hidden my-2" />
            <div v-if="comment.replies && comment.replies.length > 0" class="mb-4 pt-1">
                <div class="flex justify-center">
                    <UAvatarGroup size="sm" :max="2">
                        <UAvatar v-for="el in comment.replies" :src="el.avatar" :alt="el.name" />
                    </UAvatarGroup>
                </div>
                <div class="flex items-center justify-between mt-4">
                    <UiComponentTypography variant="subtitle2">
                        {{ comment.replies?.length }} پاسخ ثبت شده
                    </UiComponentTypography>
                    <!-- <UButton variant="soft" size="2xs" color="vista" v-if="openRepliesIndex.includes(index)" @click="
                        openRepliesIndex.includes(index) &&
                        openRepliesIndex.splice(openRepliesIndex.indexOf(index), 1)
                        ">
                        بستن
                    </UButton>
                    <UButton variant="soft" size="2xs" color="vista" v-else @click="openRepliesIndex.push(index)">
                        مشاهده همه
                    </UButton> -->
                </div>
            </div>
            <div class="flex justify-end">
                <UButton variant="ghost" size="2xs" icon="i-solar-reply-2-bold-duotone"
                    @click="emits('replyComment', index)">
                    پاسخ به این پیام
                </UButton>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import type { IComment } from '~/libs/types/api/comments';

const props = defineProps({
    comment: {
        type: Object as PropType<IComment>,
        required: true
    },
    index: {
        type: Number,
        required: true
    }
})

const { width } = useWindowSize();

const isDesktop = computed(() => {
    return width.value > 1024;
});

const emits = defineEmits(["replyComment"]);

</script>

<style></style>